import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'clsx';

import { Text, TextType } from 'ui-components/components/text';

import { CountryConfigNames } from '../../../../../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../../../../../hooks/use-country-config';
import { getXCoverTermsLinks } from '../../../../../../insurance/xcover-terms-links';
import { TermLink } from '../../../../../components/term-link';
import { insuranceTermsCheckboxMessages } from './insurance-terms-checkbox-messages';
import styles from './insurance-terms-checkbox.module.less';

const POLICY_TERMS_KEY = 'InsurancePolicyTerms';
const IPID_KEY = 'InsuranceProductInformationDocument';

const countryOfResidenceMessageByVariant = {
  gb: insuranceTermsCheckboxMessages.countryOfResidenceGB,
  de: insuranceTermsCheckboxMessages.countryOfResidenceDE,
} as const;

type Props = {
  className?: string;
};

export const InsuranceTermsNotice = ({ className }: Props) => {
  const [isEnabled, { variant }] = useCountryConfig(CountryConfigNames.InsuranceTermsAcknowledgement);
  const links = getXCoverTermsLinks(variant);
  const countryOfResidenceMessage = variant
    ? countryOfResidenceMessageByVariant[variant as keyof typeof countryOfResidenceMessageByVariant]
    : undefined;

  if (!isEnabled || !links || !countryOfResidenceMessage) {
    return null;
  }

  return (
    <div className={classnames(styles['insurance-terms-container'], className)}>
      <Text className={styles['insurance-terms-title']} isBold textType={TextType.Paragraph} value={insuranceTermsCheckboxMessages.title} />
      <Text
        className={styles['insurance-terms-text']}
        formattedMessageValues={{
          policyTerms: (
            <TermLink
              iconClass={styles['external-link-icon']}
              linkClass={styles['terms-link']}
              termKey={POLICY_TERMS_KEY}
              termText={insuranceTermsCheckboxMessages.policyTerms}
              termUrl={links.policyTerms}
            />
          ),
          insuranceProductInformationDocument: (
            <TermLink
              iconClass={styles['external-link-icon']}
              linkClass={styles['terms-link']}
              termKey={IPID_KEY}
              termText={insuranceTermsCheckboxMessages.insuranceProductInformationDocument}
              termUrl={links.insuranceProductInformationDocument}
            />
          ),
          countryOfResidence: <FormattedMessage {...countryOfResidenceMessage} />,
        }}
        textType={TextType.Paragraph}
        value={insuranceTermsCheckboxMessages.acknowledgement}
      />
    </div>
  );
};
